'use strict';
var CredentialListController = /** @class */ (function () {
    /*@ngInject*/
    function CredentialListController($scope, $mdDialog, Util, Auth, $cookies, $timeout, Upload, CredentialListService, seoMetaService) {
        this.sortType = 'orderDate';
        this.sortReverse = false;
        this.searchOrderDate = '';
        this.certificationsContentPara1 = "To access all available products for your profession at wholesale pricing, \n                    you must upload your professional or business credentials. These could include: diploma, \n                    certification, state license, or business certificate. If you are a student, \n                    we need your current student ID or an up-to-date copy of your transcript indicating your enrollment.<br><br>\n                    You may place one order at wholesale cost while you wait for your credentials to be approved. \n                    If you do not upload credentials (or your credentials are denied) within 7 days of your account creation, \n                    you will not be able to submit another order.<br><br> If you have any questions, or need\n                    help getting your account set up, our Customer Support team will be happy to help! \n                    Call us Monday-Friday 8:30 a.m.-8 p.m. at 800.654.4432.";
        this.credentialType = null;
        this.selectedCredential = null;
        this.files = null;
        this.file = null;
        this.log = null;
        this.progressPercentage = 0;
        this.credentialBeingEdited = null;
        this.credentialAddFormValid = false;
        this.rxCredential = false;
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        this.errorGettingCredentials = false;
        this.loadingBar = false;
        this.showAlert = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.$scope = $scope;
        this.Upload = Upload;
        this.Util = Util;
        this.Auth = Auth;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.credentialListService = CredentialListService;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'CredentialListController');
        var self = this;
        self.credentials = [{}];
        self.refreshCredentialsList();
        this.credentialListService.getDoctorTypes().then(function (response) {
            self.credentialTypes = response.data.response.currentPage;
        });
        $scope.$watch('$ctrl.files', function () {
            console.log('In watch files');
            //self.upload(self.files);
        });
        $scope.$watch('$ctrl.file', function () {
            if (self.file != null && self.selectedCredential != null) {
                console.log('Adding file-> ', self.file);
                if (self.files == null)
                    self.files = [];
                self.files.push(self.file);
                self.selectedCredential.status = 'Upload Pending';
                self.selectedCredential.file = self.file;
            }
        });
        $scope.$on('credentialUploaded', function (event, data) {
            self.refreshCredentialsList();
        });
        $scope.$on('credentialAddFormValid', function (event, data) {
            self.credentialAddFormValid = data;
        });
        self.log = '';
        self.uploadError = false;
        self.uploadErrorMsg = '';
    }
    CredentialListController.prototype.refreshCredentialsList = function () {
        var self = this;
        self.loadingBar = true;
        self.errorGettingCredentials = false;
        this.credentialListService.getCredentials().then(function (response) {
            console.log('Credential List Response -> ', response);
            if (response.status == 200 && response.data) {
                self.credentialsList = response.data;
                var i;
                for (i in self.credentialsList) {
                    if (self.credentialsList[i].credentialType == null) {
                        self.credentialsList[i].credentialType = 'Other';
                    }
                    if (self.credentialsList[i].hasCredential == 'False') {
                        self.credentialsList[i].status = "Not Uploaded";
                    }
                }
                console.log('Received Credentials -> ', self.credentialsList);
            }
        })
            .catch(function () { return self.errorGettingCredentials = true; })
            .finally(function () { return self.loadingBar = false; });
    };
    CredentialListController.prototype.addCredential = function (event) {
        var self = this;
        self.credentials = [];
        self.credentials.push(event.credential);
        console.log('Adding Credential Received ->', event.credential);
        self.loadingBar = true;
        self.$scope.$broadcast('AddCredentialStarted', true);
        self.upload(event.credential);
        self.credentialAddFormValid = false;
    };
    CredentialListController.prototype.editCredential = function (credentialId) {
        this.credentialBeingEdited = credentialId;
    };
    CredentialListController.prototype.upload = function (credential) {
        this.Auth.clearAccountCache();
        var self = this;
        if (credential) {
            if (!credential.$error && (self.rxCredential ? credential.credentialType != null : true)) {
                var xsrf_token = this.$cookies.get('XSRF-TOKEN');
                self.Upload.upload({
                    url: '/api/account/credentials',
                    headers: {
                        'X-XSRF-TOKEN': xsrf_token
                    },
                    data: {
                        doctorTypeId: credential.doctorType.doctorTypeID,
                        doctorTypeKey: credential.doctorType.doctorTypeKey,
                        file: credential.file
                    }
                }).then(function (resp) {
                    self.$timeout(function () {
                        if (resp.config.data.file) {
                            self.log = 'file: ' +
                                resp.config.data.file.name;
                        }
                        self.log = self.log + ', Response: ' + JSON.stringify(resp.data) + '\n';
                        self.loadingBar = false;
                        credential.status = 'PENDING REVIEW';
                        console.log(self.log);
                        if (resp.status != 200 || (resp.data && resp.data.errors && resp.data.errors.length)) {
                            if (resp.status === 413) {
                                var errorResponse = resp;
                                errorResponse.data = {
                                    errors: 'Image size exceeds maximum allowed limit. Please upload an image with a smaller file size.'
                                };
                                self.Util.handleApiError(errorResponse, self);
                            }
                            else {
                                self.Util.handleApiError(resp, self);
                            }
                            self.$scope.$broadcast('AddCredentialError', resp);
                        }
                        else {
                            self.Util.resetApiError(self);
                            self.$scope.$broadcast('AddCredentialFinished', true);
                            self.closeDialog();
                            self.refreshCredentialsList();
                        }
                    });
                }, function (response) {
                    credential.status = 'UPLOAD FAILED';
                    self.loadingBar = false;
                    if (response.status != 200 || (response.data && response.data.errors && response.data.errors.length)) {
                        self.Util.handleApiError(response, self);
                    }
                    self.$scope.$broadcast('AddCredentialError', response);
                }, function (evt) {
                    self.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if (credential) {
                        self.log = 'progress: ' + self.progressPercentage + '% ' + evt.config.data.file.name
                            + '\n' + self.log;
                        console.log(self.log);
                    }
                    self.uploadError = true;
                    self.uploadErrorMsg = 'UPLOADING';
                    credential.status = 'UPLOADING';
                });
            }
        }
    };
    CredentialListController.prototype.changeCredType = function (credential) {
        this.selectedCredential = credential;
    };
    CredentialListController.prototype.closeDialog = function () {
        this.$mdDialog.hide();
    };
    CredentialListController.prototype.submitForm = function ($event) {
        $event.preventDefault();
        this.action = 'Add';
        this.$scope.$broadcast('submitForm', {});
    };
    CredentialListController.prototype.isFormValid = function () {
        return this.credentialAddFormValid;
    };
    return CredentialListController;
}());
export default CredentialListController;
//# sourceMappingURL=credential-list.controller.js.map